<template>
  <div id="forgot-password">
    <div id="change-success">
      <h2>{{ $t('resetting_a_password') }}</h2>
      <p class="center mb40">{{ $t('password_reset_is_complete') }}</p>
      <div class="btn-base"><router-link :to="'login'" class="btn-base"><p>{{ $t('return_to_login_screen') }}</p></router-link></div>
    </div>
  </div>
</template>

<script>
  import { Strings } from "@/js/commons/strings"

  export default {
    data() {
      return {
        Strings: Strings
      }
    },
    mounted() {
      this.screenTracking(this.$t('pw_reset_completed'))
    }
  }
</script>